import { render } from "./InternalRepairs.vue?vue&type=template&id=a150bf3a"
import script from "./InternalRepairs.vue?vue&type=script&lang=js"
export * from "./InternalRepairs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__